import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import { AccountingPhysicalDefaultCommissionActions } from ".";
import { initialPhysicalDefaultCommissionState } from "./PhysicalDefaultCommission.types";
    import { CLEAR_PHYSICAL_DEFAULT_COMMISSION, FETCH_PHYSICAL_DEFAULT_COMMISSION_FAILURE, FETCH_PHYSICAL_DEFAULT_COMMISSION_LIST_FAILURE, FETCH_PHYSICAL_DEFAULT_COMMISSION_LIST_PROGRESS, FETCH_PHYSICAL_DEFAULT_COMMISSION_LIST_SUCCESS, FETCH_PHYSICAL_DEFAULT_COMMISSION_PROGRESS, FETCH_PHYSICAL_DEFAULT_COMMISSION_SUCCESS } from "./PhysicalDefaultCommissionActions";



export const AccountingPhysicalDefaultCommissionReducer = (
  state: IStoreState["accounting"]["physicalDefaultCommission"] = initialPhysicalDefaultCommissionState,
  action: AccountingPhysicalDefaultCommissionActions
) => {
  switch (action.type) {
    case FETCH_PHYSICAL_DEFAULT_COMMISSION_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_PHYSICAL_DEFAULT_COMMISSION_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.Loaded;
        draftState.list = data;
      });
      return newState;
    }

    case FETCH_PHYSICAL_DEFAULT_COMMISSION_LIST_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.Failed;
        draftState.error = errorMessage;
      });
      return newState;
    }

    case FETCH_PHYSICAL_DEFAULT_COMMISSION_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_PHYSICAL_DEFAULT_COMMISSION_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.data = data;
      });
      return newState;
    }

    case FETCH_PHYSICAL_DEFAULT_COMMISSION_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
      });
      return newState;
    }

    case CLEAR_PHYSICAL_DEFAULT_COMMISSION: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.NotLoaded;
        draftState.data = initialPhysicalDefaultCommissionState.data;
        draftState.error = null;
      });
      return newState;
    }

    default:
      return state;
  }
};
